export const rendererCapacity = {
  maxNodes: 256,
  maxConnections: 4096
} as const;
